import { apiClient } from '@/shared/data/client';
import type { GridQueryInput } from '@/ui/composites/grid/gridUtils';
import type { FeedbackCategory, FeedbackDto, FeedbackPriority, QueryResult } from '@flowqa/shared';

export type FeedbackCreateInput = {
  subject: string;
  body: string;
  contactRequested: boolean;
  sourcePath: string;
};

export const createFeedback = async (input: FeedbackCreateInput): Promise<FeedbackDto> => {
  return await apiClient.post<FeedbackDto>('feedback', input);
};

export const querySuperuserFeedback = async (
  input: GridQueryInput,
): Promise<QueryResult<FeedbackDto>> => {
  return await apiClient.post<QueryResult<FeedbackDto>>('superuser/feedback/query', input);
};

export const closeSuperuserFeedback = async (id: string): Promise<FeedbackDto> => {
  return await apiClient.post<FeedbackDto>(`superuser/feedback/${id}/close`, undefined);
};

export const reopenSuperuserFeedback = async (id: string): Promise<FeedbackDto> => {
  return await apiClient.post<FeedbackDto>(`superuser/feedback/${id}/reopen`, undefined);
};

export type FeedbackUpdateInput = {
  category?: FeedbackCategory | null;
  priority?: FeedbackPriority | null;
};

export const updateSuperuserFeedback = async (
  id: string,
  input: FeedbackUpdateInput,
): Promise<FeedbackDto> => {
  return await apiClient.post<FeedbackDto>(`superuser/feedback/${id}/update`, input);
};
